import { COOKIES } from '@constants/cookies';
import { getCookie } from '@services/cookies';

export const getCurrency = () => {
  const currency = getCookie(COOKIES.currency);
  return currency ? currency : 'GBP';
};
